export const MOBILE_WIDTH = 830; // standard width adhering to Recess styles in Header and Footer
export const MOBILE_QUERY = Object.freeze({
    query: `(max-width: ${MOBILE_WIDTH}px)`,
});
